import { FC } from 'react'

import { EditIcon } from '@Static/icons/AccountMenuIcon'
import { CloseIcon } from '@Static/icons/ArrowIcons'
import { BellIcon } from '@Static/icons/FooterIcons'
import { MarginRefreshIcon } from '@Static/icons/MarginTransferModalIcons'

import { formatServerDate } from '@App/helpers/time'
import { useAppDispatch } from '@App/hooks'

import { MODAL_TYPES } from '@Redux/slices/modals/enums'
import { setModal } from '@Redux/slices/modals/ModalSlice'
import { sendUpdatePriceAlert } from "@Redux/slices/sockets/ProxyServiceConnectionSlice";

import { AlertTypeMarker } from '@UI/crypto_exchange/desktop/pages/spot/components/PriceAlert/components/AlertTypeMarker/AlertTypeMarker'
import { ButtonControl } from '@UI/crypto_exchange/desktop/pages/spot/components/PriceAlert/components/ButtonControl/ButtonControl'
import { AlertType } from '@UI/crypto_exchange/desktop/pages/spot/components/PriceAlert/types'

import s from './styles.module.scss'

type CreatedPriceAlertProps = {
  alerts: AlertType[]
  targetCurrency: string
  sourceCurrency: string
}

export const PriceAlerts: FC<CreatedPriceAlertProps> = ({ alerts, targetCurrency, sourceCurrency }) => {
  const dispatch = useAppDispatch()

  const openEditModal = (data: AlertType) => {
    dispatch(
      setModal({
        modalType: MODAL_TYPES.EDIT_ALERT_MODAL,
        data: {
          prevData: data,
          targetCurrency,
          sourceCurrency,
        },
      }),
    )
  }

  const openRemoveModal = (ids: string[]) => {
    dispatch(
      setModal({
        modalType: MODAL_TYPES.REMOVE_ALERT_MODAL,
        data: { ids },
      }),
    )
  }

  const refreshAlert = (id: string) => {
    dispatch(sendUpdatePriceAlert({uuid: id}))
  }

  return (
    <div className={s.wrapper}>
      {alerts.length > 1 && (
        <ButtonControl onClick={() => openRemoveModal(alerts.map((i) => i.uuid))}>Remove all</ButtonControl>
      )}

      <div className={s.listWrapper}>
        {!!alerts.length ? (
          alerts.map((item) => (
            <div className={s.listItem}>
              <div className={s.listItemHeader}>
                <div className={s.listItemHeaderInfo}>
                  <AlertTypeMarker type={item.side} />
                  <span className={s.value}>{item.execution_price}</span>
                </div>

                <div className={s.controlGroup}>
                  {item.completed_at &&
                    <span onClick={() => refreshAlert(item.uuid)} className={s.controlButton}>
                      <MarginRefreshIcon/>
                    </span>
                  }
                  <span onClick={() => openEditModal(item)} className={s.controlButton}>
                    <EditIcon/>
                  </span>
                  <span className={s.controlButton} onClick={() => openRemoveModal([item.uuid])}>
                    <CloseIcon/>
                  </span>
                </div>
              </div>

              {item.note && <div className={s.note}>{item.note}</div>}

              {item.completed_at && (
                <div className={s.triggerTime}>
                  <span className={s.controlButton}>
                    <BellIcon />
                  </span>
                  <div className={s.note}>{formatServerDate(item.completed_at)}</div>
                </div>
              )}
            </div>
          ))
        ) : (
          <div className={s.noAlerts}>
            <BellIcon />
            <p>No alerts</p>
          </div>
        )}
      </div>
    </div>
  )
}
